/* angular libs */
import { NgModule } from '@angular/core';
import { FormatPhoneNumberPipe } from './format-phone-number.pipe';

/* pipe */



@NgModule({
  imports: [
  ],
  providers: [
  ],
  declarations: [
    FormatPhoneNumberPipe
  ],
  exports: [
    FormatPhoneNumberPipe
  ]
})
export class FormatPhoneNumberModule {
}
